
import { useContext, useRef } from 'react'
import Navbar from './navbar/Navbar'
import { AppContext } from '../contextApi/ContextApi'
import ClientContextProvider from '../contextApi/ClientContext';
import Footer from './Footer';
import Cookies from './Cookies';
import WebsiteNotActive from './WebsiteNotActive';

export default function ClientPage({child}) {
    const {currentWebsite, primary_color, accent_color, secondary_color, cookiesApprooved, navbarArr} = useContext(AppContext);
    const navRef = useRef(null);
    
    return (
        <ClientContextProvider>
            {/* for mobile responsivity - remove the minWidth attribute and change according to media screen width on css */}
            {currentWebsite?.settings?.isActive ? 
                <div style={{backgroundColor:secondary_color ,color:accent_color,minHeight:"100vh", borderBottom:`3px solid ${primary_color}`, minWidth:"850px"}}>
                    <Navbar isDashboard={false} navRef={navRef} navbarArr={navbarArr}/>
                    {child}
                <Footer isDashboard={false} navRef={navRef} navbarArr={navbarArr}/>
                </div> :
                <WebsiteNotActive isDashboard={false}/>
            }
            {!cookiesApprooved ? <Cookies/> : null}
        </ClientContextProvider>
    )
}
